import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '../../spacesPlatform/models/ISpaceItemDetailInfo';
import { ContentDraftStatus } from '../serverApi/types/ContentDraft';
import { DraftsState,DraftWorkbookSpaceProps } from '../types/DraftsTypes';

// TLDR flow drafts that have never been published have a flow id that is mapped to the draft id with a prefix
// Why? Flows and flow drafts are in separate databases on the BE and can have id collisions. These id collisions can cause problems in data grids,
// specifically in the case where a flow draft id collides with a flow id, and they're in the same grid. Flow drafts that have never been
// published don't have a flow associated with them, so they don't have an actual flow id. For these cases, we map the "flow" id to the draftId. The
// prefix is necessary to alleviate the issue with id collisions between flows and flow drafts that have never been published.
const DRAFT_ID_PREFIX: string = 'draftid-';

export function appendDraftIdPrefix(id: string): string {
  return DRAFT_ID_PREFIX + id;
}

// generally useful when you need to call an action specific to flow drafts, the BE can't parse non number strings so we must
// strip off the draft id prefix on the FE
export function removeDraftIdPrefix(id: string): string {
  if (hasDraftIdPrefix(id)) {
    return id.split(DRAFT_ID_PREFIX)[1];
  } else {
    return id;
  }
}

export function hasDraftIdPrefix(id: string): boolean {
  return id.search(DRAFT_ID_PREFIX) !== -1;
}

export function localizeDraftStatus(status: string): string {
  switch (status) {
    case ContentDraftStatus.unpublishedchanges:
      return Messages.draftMarkerUnpublishedChanges();
    case ContentDraftStatus.unpublished:
      return Messages.draftMarkerUnpublished();
    case ContentDraftStatus.none:
    default:
      return '';
  }
}

export function getDraftInfoForHeaderBanner(draftState: DraftsState): DraftWorkbookSpaceProps {
  let draft = draftState.drafts;
  try {
    let draftLuid = Object.keys(draft)[0];  // there should only be one draft in object
    return {
      draftUpdatedAt: draft[draftLuid].updatedAt,
      draftLuid
    };
  } catch (e) {
    return;
  }
}

function isSpaceItemDetailInfoFlow(flow: IContentInfo<'flow'> | ISpaceItemDetailInfo<'flow'>): flow is ISpaceItemDetailInfo<'flow'> {
  return (flow as ISpaceItemDetailInfo<'flow'>).flowDraft !== undefined;
}

export function getFlowDraftId(flow: IContentInfo<'flow'> | ISpaceItemDetailInfo<'flow'>) {
  if (isSpaceItemDetailInfoFlow(flow) && flow.flowDraft.id) {
    return flow.flowDraft.id;
  } else if (flow.draftId) {
    return flow.draftId;
  }
}

export function isValidDraftStatus(draftStatus: string): boolean {
  let status = draftStatus as ContentDraftStatus;
  return (status === ContentDraftStatus.unpublished || status === ContentDraftStatus.unpublishedchanges);
}
